export const visit = (vm, at) => {
vm(require("property-management-iframe/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("marketplace-storefront-base/lang/en.lyaml"));
vm(require("ui-universal-auth/lang/en.lyaml"));
vm(require("customer-data-property-utils/lang/en.lyaml"));
vm(require("integrations-lib/lang/en.lyaml"));
vm(require("marketplace-ui-install/lang/en.lyaml"));
at({ "en": { "marketplaceStorefrontPublicUi": { "hello": "world" } } });
};